import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { SITE } from "../components/Seo/Seo";
import "./Layout.css";

// Organization data for search engines — public business details as
// published in the footer and imprint.
const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": `${SITE.url}/#organization`,
  name: "Nexite IT",
  description:
    "Agentur für Webentwicklung, App-Entwicklung und UI/UX Design aus Köln.",
  url: `${SITE.url}/`,
  logo: `${SITE.url}/logo512.svg`,
  image: SITE.defaultImage,
  email: "info@nexite-it.com",
  telephone: "+49 178 8622282",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Auf dem Schnorrenberg 6",
    postalCode: "50354",
    addressLocality: "Hürth",
    addressRegion: "Nordrhein-Westfalen",
    addressCountry: "DE",
  },
  areaServed: ["Köln", "Bonn", "Hürth", "Deutschland"],
  sameAs: ["https://www.linkedin.com/company/nexite-it/"],
};

const Layout = () => {
  return (
    <div className="page-container">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}
      />

      <Navbar />
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
